<template>
  <div class="main_body">
    <loading :active="isLoading" :is-full-page="fullPage" :loader="loader" />
    <div class="container-fluid">
      <div class="row row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
        <div style="margin-left:20px;" class="pb-4">
                <h3>Last Failed Transaction</h3>
            </div>
      </div>
      <div>
        <h3 style="color:white;">Select number of data</h3>
        <form @submit.prevent="processForm">
          <select v-model="columns" id="cars">
            <option style="display:none;" selected value="">Select one</option>
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="20">20</option>
            <option :value=count>All</option>
          </select><br><br>
          <button class="btn btn-success">Submit</button>
        </form>

      </div>
      <div style="overflow-x:auto">
      <table class="table" style="">
        <thead>
          <tr v-if="flags === true">
            <th>User Name</th>
            <th>Full Name</th>
            <!-- <th>Phone no</th> -->
            <th>ID</th>
            <th>Order ID</th>
            <th>Customer Order ID</th>
            <!-- <th>Invoice No</th> -->
            <th>Amount</th>
            <!-- <th>Currency</th> -->
            <th>Customer Name</th>
            <th>Customer Address</th>
            <th>Customer City</th>
            <!-- <th>Sp Message</th> -->
            <!-- <th>Client IP</th> -->
            <th>Transaction Status</th>
            <!-- <th>Completed</th> -->
            <!-- <th>Deleted</th> -->
            <!-- <th>User ID</th> -->
            <!-- <th>AudioBook ID</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in transactionList" :key="index">
            <td>{{ data.user_name }}</td>
            <td>{{ data.full_name }}</td>
            <!-- <td>{{ data.phone_no }}</td> -->
            <td>{{ data.id }}</td>
            <td>{{ data.sp_order_id }}</td>
            <td>{{ data.customer_order_id }}</td>
            <!-- <td>{{data.invoice_no}}</td> -->
            <td>{{ data.amount }}</td>
            <!-- <td>{{data.currency}}</td> -->
            <td>{{ data.customer_name }}</td>
            <td>{{ data.customer_address }}</td>
            <td>{{ data.customer_city }}</td>
            <!-- <td>{{data.sp_massage}}</td> -->
            <!-- <td>{{data.client_ip}}</td> -->
            <td>{{ data.transaction_status }}</td>
            <!-- <td>{{data.completed}}</td> -->
            <!-- <td>{{data.deleted}}</td> -->

          </tr>
        </tbody>
      </table>
      </div>
      <div style="overflow-x:auto">
      <table v-if="flags === false" class="table" style="">
        <thead>
          <tr>
            <th>User Name</th>
            <th>Full Name</th>
            <!-- <th>Phone no</th> -->
            <th>ID</th>
            <th>Order ID</th>
            <th>Customer Order ID</th>
            <!-- <th>Invoice No</th> -->
            <th>Amount</th>
            <!-- <th>Currency</th> -->
            <th>Customer Name</th>
            <th>Customer Address</th>
            <th>Customer City</th>
            <!-- <th>Sp Message</th> -->
            <!-- <th>Client IP</th> -->
            <th>Transaction Status</th>
            <!-- <th>Completed</th> -->
            <!-- <th>Deleted</th> -->
            <!-- <th>User ID</th> -->
            <!-- <th>AudioBook ID</th> -->
          </tr>
        </thead>
        <tbody>
          <tr v-for="(data, index) in lists" :key="index">
            <td>{{ data.user_name }}</td>
            <td>{{ data.full_name }}</td>
            <!-- <td>{{ data.phone_no }}</td> -->
            <td>{{ data.id }}</td>
            <td>{{ data.sp_order_id }}</td>
            <td>{{ data.customer_order_id }}</td>
            <!-- <td>{{data.invoice_no}}</td> -->
            <td>{{ data.amount }}</td>
            <!-- <td>{{data.currency}}</td> -->
            <td>{{ data.customer_name }}</td>
            <td>{{ data.customer_address }}</td>
            <td>{{ data.customer_city }}</td>
            <!-- <td>{{data.sp_massage}}</td> -->
            <!-- <td>{{data.client_ip}}</td> -->
            <td>{{ data.transaction_status }}</td>
            <!-- <td>{{data.completed}}</td> -->
            <!-- <td>{{data.deleted}}</td> -->

          </tr>
        </tbody>

      </table>
</div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import axios from "axios";
export default {
  data() {
    return {
      transactionList: "",
      flags: false,
      columns: "",
      lists: "",
      isLoading: false,
      fullPage: true,
      loader: "bars",
      clickFlag: false,
      count: ""
    }
  },
  components: {
    Loading
  },

  created() {
    this.failedList()
  },
  methods: {
    processForm() {
      if (this.checkForm) {
        this.flags = true
        this.list()
      }
    },
    checkForm() {
      if (this.columns) {

        return true
      }
      this.errors = []
      if (!this.columns) {
        this.errors.push("Select number of columns")
        return false
      }
    },
    async list() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/last-failed-transaction-list?totalTransaction=" + this.columns, {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
        );
        if (res.status == 200) {
          // console.log(res)
          this.transactionList = res.data.data
          console.log(this.transactionList)
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
    async failedList() {
      const token = localStorage.getItem(this.$tokenKey);
      try {
        this.isLoading = true
        const res = await axios.get(
          this.$baseUrl + this.$api + this.$version1 + "/kabbikanalytics/last-failed-transaction-list?totalTransaction=10", {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          }
        }
        );
        if (res.status == 200) {
          // console.log(res)
          this.lists = res.data.data
          this.count = res.data.total_item[0].total
          this.isLoading = false;
          // console.log(this.datewisePurchase)
        }
      } catch (error) {
        console.log(error);
        this.isLoading = false;
      }
    },
  }
}
</script>